import React, { useEffect, useState } from "react";
import { CustomButton } from "../../../components/button/CustomButton";
import { ContestsModal } from "../../../components/modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import {

  createParticipateContestThunk as onCreateParticipateContestThunk,
  handleStartDesignThunk as onHandleStartDesignThunk

} from "../../../slices/contest/thunk";
import { createSelector } from "@reduxjs/toolkit";
import { resetContestThunk as onResetContest } from "../../../slices/contest/thunk";
import { Spinner } from "../../../components/spinner/Spinner";
import { useNavigate } from "react-router-dom";
import { getAuthUser } from "../../../utils/GetAuthUser";

function ParticipateContest({ description,contestId,isStartDesigning,contestParticipateId}) {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [modalOpen, setModalOpen] = useState(false);
  const [showIsLoader, setShowIsLoader] = useState(false);
  const [isParticipateDone, setIsParticipateDone] = useState(false);
 const [designStart, setDesignStart] = useState(false);
  const selectContestState = (state) => state.contest;
  const contestSelector = createSelector(selectContestState, (contest) => ({
    isLoading: contest.isLoading,
    isCreateContest: contest.isCreateContest,
    isParticipate: contest.isParticipate,
    isDesigningStart:contest.isDesigningStart
    
  }));

  const { isLoading, isCreateContest, isParticipate,isDesigningStart } =useSelector(contestSelector);
  const authUser = getAuthUser();

  dispatch(onResetContest());

  useEffect(() => {
    setShowIsLoader(isLoading);
    if (isCreateContest) {
      setModalOpen(true);
    }
  }, [isCreateContest, isLoading]);

    useEffect(() => {
  
    if (isDesigningStart) {
    setDesignStart(true);
    }
  }, [isDesigningStart]);

  useEffect(() => {
    setIsParticipateDone(isParticipate);
  }, [isParticipate]);

    useEffect(() => {
    if (designStart) {
      navigate("/artist/your-contest");
    }
setDesignStart(false)
  }, [designStart,navigate]);

  useEffect(() => {
    if (isParticipateDone) {
      navigate("/artist/contests/140");
    }
  }, [isParticipateDone, navigate]);

  const handleParticipateContest = () => {
    dispatch(onResetContest());
    dispatch(
      onCreateParticipateContestThunk({
        contestId: contestId,
        artistId: authUser ? authUser.user.id : null,
        is_accept: 1,
      })
    );
  };

    const handleStartDesign = () => {
    dispatch(onResetContest());
    dispatch(
      onHandleStartDesignThunk({
        contestParticipateId:contestParticipateId,
      })
    );
  };

  return (
    <div className="w-full  flex flex-col items-center justify-start">
      <div className="w-full border border-border_color rounded-[14px] flex flex-col p-2 sm:p-4 items-center">
        <p className="w-full  min-h-[150px] p-1 rounded-xl text-sm">
          {description}
        </p>
      </div>
      <div className={`w-full flex flex-col sm:flex-row items-center justify-center gap-4 mt-10  ${isStartDesigning ? "sm:mt-24" : "sm:mt-24"}`}>

      {isStartDesigning ? (
  <CustomButton
    onClick={() => handleStartDesign()}
    text={showIsLoader ? <Spinner /> : "Start Designing"}
    disabled={isLoading}
  />
) : (
  <CustomButton
    onClick={() => handleParticipateContest()}
    text={showIsLoader ? <Spinner /> : "Participate"}
    disabled={isLoading}
  />
)}

    
      
      </div>
      <ContestsModal
        openModal={modalOpen}
        closeModal={() => setModalOpen(false)}
      />
    </div>
  );
}

export default ParticipateContest;
